export const FoodArray = [
  {
    img: "https://blog.radissonblu.com/wp-content/uploads/2019/05/GettyImages-493613257.jpg",
    title: "Kibbe",
    id: "156",
    cal: "260",
    time: "10",
    category: ["Meat"],
    ingredients: ["Berghol", "Meat"],
  },
  {
    img: "https://www.abouther.com/sites/default/files/2018/05/11/shutterstock_248472739.jpg",
    title: "Hummus",
    time: "15",
    cal: "178",
    id: "510",
    category: ["Lunch"],
  },
  {
    img: "https://media-cdn.tripadvisor.com/media/photo-s/16/f4/0c/57/half-zaatar-half-cheese.jpg",
    title: "Manakish",
    cal: "260",
    time: "70",
    id: "420",
    category: ["Breakfast"],
  },
  {
    img: "https://www.fadiscuisine.com/wp-content/uploads/2016/12/tabouleh.jpg",
    title: "Tabouleh",
    cal: "136",
    time: "30",
    id: "69",
    category: ["Veggies"],
  },
  {
    img: "https://i0.wp.com/www.arabamerica.com/wp-content/uploads/2021/01/knafeh-dubai-food.jpg",
    title: "Knafe",
    cal: "230",
    time: "40",
    id: "99",
    category: ["Dessert"],
    ingredients: ["Qashta"],
  },
  {
    img: "https://280337.smushcdn.com/1648336/wp-content/uploads/2019/09/learning-historical-origins-baklava.jpg",
    title: "Baklava",
    cal: "120",
    time: "63",
    id: "888",
    category: ["Dessert"],
  },
];

export const categoryArray = [
  {
    title: "",
    image: "https://image.flaticon.com/icons/png/128/40/40894.png",
  },
  {
    title: "Veggies",
    image: "https://image.flaticon.com/icons/png/128/4163/4163765.png",
  },
  {
    title: "Meat",
    image: "https://image.flaticon.com/icons/png/128/869/869676.png",
  },
  {
    title: "Fish",
    image: "https://image.flaticon.com/icons/png/128/3347/3347364.png",
  },
  {
    title: "Dessert",
    image: "https://image.flaticon.com/icons/png/128/992/992717.png",
  },
  {
    title: "Fruits",
    image: "https://image.flaticon.com/icons/png/128/1625/1625048.png",
  },
  {
    title: "Drinks",
    image: "https://image.flaticon.com/icons/png/128/3165/3165589.png",
  },
  {
    title: "Breakfast",
    image: "https://image.flaticon.com/icons/png/128/3480/3480823.png",
  },
  {
    title: "Lunch",
    image: "https://image.flaticon.com/icons/png/128/2276/2276931.png",
  },
  {
    title: "Dinner",
    image: "https://image.flaticon.com/icons/png/128/3480/3480618.png",
  },
];

export const ingredientsArray = [
  {
    title: "Qashta",
    image:
      "https://www.abwfoods.com.au/wp-content/uploads/2017/05/spreadable-cheese-cream-cheese-spread.png",
  },
  {
    title: "Meat",
    image: "https://image.flaticon.com/icons/png/128/869/869676.png",
  },
  {
    title: "Hommos",
    image:
      "https://welcometogreenvalley.com/wp-content/uploads/2015/08/green-valley-garbanzo-beans-bowl-1051x1100.png",
  },
  {
    title: "T'hine",
    image:
      "https://lh3.googleusercontent.com/proxy/HasLDEcV9rR9j6UnmXCQLbrHWBdoE82pJ8aCtJVGs-2CDWva0GuD4SKaoZJpnz0HzuPBRlKz_q4YANPdSTebbP971WRb-gXIk2ZTa6OU1Q",
  },
  {
    title: "Garlic",
    image: "https://clipart-best.com/img/garlic/garlic-clip-art-43.png",
  },
  {
    title: "Zeit",
    image:
      "https://w7.pngwing.com/pngs/993/747/png-transparent-italian-cuisine-greek-cuisine-ingredient-olive-olive-oil-spices-food-olive-oil.png",
  },
  {
    title: "Berghol",
    image:
      "https://e7.pngegg.com/pngimages/394/242/png-clipart-bulgur-whole-grain-kasha-food-cooking-cooking-food-cooking.png",
  },
];
